module.exports = __webpack_public_path__ + "img/bbbce8a.png";